// Cinematic scroll-scale effect — GSAP + ScrollTrigger. Loaded as a plain
// classic script (not a module), right after the GSAP/ScrollTrigger CDN
// tags in theme.liquid, so `gsap`/`ScrollTrigger` are already defined on
// window by the time this parses.
//
// Usage: put data-parallax-image on the (overflow:hidden) container that
// wraps a hero/banner image — its <img>/<svg> children smoothly scale up
// as the section scrolls through the viewport, tied to scroll position
// (scrub), not a fixed duration — same "cinematic zoom" feel as a Ken
// Burns effect. Per ui-ux-pro-max's Parallax Scroll guidance: applied to
// the image layer only (never text/controls), and skipped entirely under
// prefers-reduced-motion rather than force-run.
(function () {
  if (typeof gsap === "undefined" || typeof ScrollTrigger === "undefined") return;
  gsap.registerPlugin(ScrollTrigger);

  if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return;

  function setUp() {
    document.querySelectorAll("[data-parallax-image]").forEach(function (container) {
      if (container.dataset.parallaxBound) return; // don't re-bind on shopify:section:load re-scans
      var media = container.querySelectorAll("img, svg");
      if (!media.length) return;
      container.dataset.parallaxBound = "true";

      gsap.fromTo(
        media,
        { scale: 1 },
        {
          scale: 1.15,
          ease: "none",
          scrollTrigger: {
            trigger: container,
            start: "top bottom",
            end: "bottom top",
            scrub: true,
          },
        }
      );
    });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", setUp);
  } else {
    setUp();
  }

  // Shopify's theme editor re-renders a section's markup on every edit
  // without a full page reload — re-scan for newly injected containers
  // and recalculate trigger positions (layout may have shifted).
  document.addEventListener("shopify:section:load", function () {
    setUp();
    ScrollTrigger.refresh();
  });
})();
